import React, { useEffect, useState, useRef } from "react";
import {
  Grid,
  Header,
  Divider,
  Table,
  label,
  Button,
  Label,
} from "semantic-ui-react";
import { reduxForm, Field, FieldArray } from "redux-form";
import {
  renderTextField,
  renderOptionField,
  amountsAre,
  branding,
} from "../formcomponents";
import NewInvoivceFieldArr from "./NewInvoivceFieldArr";
import axios from "axios";
import { BaseUrlInvoice, ImageUrl } from "../formcomponents/Constants";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router";
import { userData } from "../store/userData";
import { useDispatch } from "react-redux";
import { addData } from "../reducer/pdfDataSlice";
import ImageFileUploadFileId from "../formcomponents/ImageFileUploadFileId";
import { useReactToPrint } from "react-to-print";
import { usePDF } from "react-to-pdf";
const NewInvoiceIndia = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const { toPDF, targetRef } = usePDF({ filename: "page.pdf" });
  const navigate = useNavigate();
  const disptch = useDispatch();
  const [userDetail, setuserDetail] = useState("");
  const [totalAmount, settotalAmount] = useState();
  const { id, catid } = useParams();
  const [buttonDisable, setbuttonDisable] = useState(false);
  const [rawData, setrawData] = useState();
  const [dataObject, setdataObject] = useState();
  const formatDateToYYYYMMDD = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const [imageUrl, setimageUrl] = useState();
  const [imageUrl2, setimageUrl2] = useState();
  const [imageUrl3, setimageUrl3] = useState();
  const [imageUrl4, setimageUrl4] = useState();
  const [imageUrl5, setimageUrl5] = useState();

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "INVOICE",
    onAfterPrint: () => alert("print SUCCESS"),
  });

  const statusVal = [
    { text: "TICKETS SEND", value: 1 },
    // { text: "Invoice Generated", value: 2 },
    { text: "PERFORMA INVOICE", value: 5 },
    { text: "AMOUNT RECEIVED", value: 3 },
    { text: "PENDING", value: 4 },
  ];

  useEffect(() => {
    const userDetail = userData();
    console.log("id", catid);
    if (id !== "null") {
      getInvoiceDetails(id);
      if (userDetail.userRole != 1) {
        setbuttonDisable(true);
      }
    } else {
      const today = new Date();
      props.initialize({
        invoiceDate: formatDateToYYYYMMDD(today),
      });
    }
    setuserDetail(userDetail);
  }, [totalAmount, disptch]);
  // Post
  // /getReceiveMoney
  // /getSpendMoney
  // /getInvoice
  // const [pdfData, setpdfData] = useState([]);

  useEffect(() => {
    getWorkCatList();
  }, []);

  const [itemDesList, setitemDesList] = useState([]);
  const getWorkCatList = async () => {
    await axios
      .post(BaseUrlInvoice + "accounts/listSSCategory", {
        categoryType: 90087,
      })
      .then((res) => {
        console.log("res", res.data);
        const resData = res.data;
        let tempList = [];
        for (let i = 0; i < resData.length; i++) {
          tempList.push({
            text: resData[i].categoryName,
            value: resData[i].categoryName,
          });
        }
        setitemDesList(tempList);
      })
      .catch((error) => console.log(error));
  };

  const getInvoiceDetails = (id) => {
    axios
      .post(BaseUrlInvoice + "accounts/getInvoice", { invoiceId: id })
      .then((res) => {
        console.log("getInvoice ----->", res.data);
        preInitialForm(res.data);
        processpdfData(res.data);
        setrawData(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [rowData, setrowData] = useState("");

  const processpdfData = (tempData) => {
    const tempObj = {
      to: tempData.invoiceName,
      date: tempData.invoiceDate,
      invoiceNumber: tempData.invoiceNumber,
      customerContact: tempData.customerContact,
      reference: tempData.reference,
      personName: tempData.personName,
      workName: tempData.workName,
      // branding: getBranding(tempData.branding),
      // amountsAre: getamountsAre(tempData.amountsAre),
      rowData: tempData.itemList,
      totalAmount: tempData.totalAmount,
    };
    disptch(addData(tempObj));
    setdataObject(tempObj);
    setrowData(tempObj);
  };

  const pdfData = {
    company: "Company Name",
    items: [
      { name: "Item 1", description: "Description 1", qty: 5, price: 10 },
      { name: "Item 2", description: "Description 2", qty: 3, price: 8 },
      // Add more items as needed
    ],
  };
  const getBranding = (record) => {
    if (record === 1) {
      return "Tax Exclusive";
    } else if (record === 1) {
      return "Tax Exclusive";
    } else if (record === 1) {
      return "Tax Exclusive";
    }
  };
  const getamountsAre = (record) => {
    if (record === 1) {
      return "Standard";
    } else if (record === 1) {
      return "Special Projects";
    } else if (record === 1) {
      return "Very Orange Invoice";
    }
  };

  const preInitialForm = (tempData) => {
    console.log(JSON.stringify(tempData, null, 2));
    props.initialize({
      invoiceId: tempData.invoiceId,
      categoryId: tempData.categoryId,
      srNumber: tempData.srNumber,
      status: tempData.status,
      userId: tempData.userId,
      invoiceName: tempData.invoiceName,
      customerContact: tempData.customerContact,
      invoiceDate: tempData.invoiceDate,
      dueDate: tempData.dueDate,
      invoiceNumber: tempData.invoiceNumber,
      reference: tempData.reference,
      branding: tempData.branding,
      amountsAre: tempData.amountsAre,
      itemList: tempData.itemList,
      totalAmount: tempData.totalAmount,
      refFile: tempData.refFile,
      refFile2: tempData.refFile2,
      refFile3: tempData.refFile3,
      refFile4: tempData.refFile4,
      refFile5: tempData.refFile5,
      personName: tempData.personName,
      workName: tempData.workName,
    });
    settotalAmount(tempData.totalAmount);
    setimageUrl(tempData.refFile);
    setimageUrl2(tempData.refFile2);
    setimageUrl3(tempData.refFile3);
    setimageUrl4(tempData.refFile4);
    setimageUrl5(tempData.refFile5);
  };

  const handleExportInvoice = () => {
    const tempObjString = JSON.stringify(rowData);
    const queryString = new URLSearchParams({ data: tempObjString }).toString();
    const url = `/export-invoice?${queryString}`;

    const a4WidthInPixels = 794; // Approximately 8.27in * 96dpi
    const a4HeightInPixels = 1123; // Approximately 11.69in * 96dpi

    const windowFeatures = `height=${a4HeightInPixels},width=${a4WidthInPixels},top=100,left=100`;
    window.open(url, "_blank", windowFeatures);
    // const windowFeatures = "height=600,width=800,top=100,left=100";
    // window.open(url, "_blank", windowFeatures);
  };
  const goBack = () => {
    navigate(-1);
  };
  const sumbitForm = (values) => {
    console.log(JSON.stringify(values, null, 2));
    if (id !== "null" && catid !== "null") {
      axios
        .post(BaseUrlInvoice + "accounts/editInvoice", values)
        .then((res) => {
          console.log(res.data);
          if (res.data.errCode === 200) {
            Swal.fire("Invoice Updated");

            navigate(`/list-invoice/${res.data.categoryId}`);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      axios
        .post(BaseUrlInvoice + "accounts/createInvoice", values)
        .then((res) => {
          console.log(res.data);
          if (res.data.errCode === 200) {
            Swal.fire("Invoice Created");

            navigate(`/list-india-invoice/${res.data.categoryId}`);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          New Invoice (INDIA)
        </Header>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      <Grid.Row>
        <Button type="submit" primary onClick={() => goBack()}>
          Go Back
        </Button>
        {rowData && (
          <Button color="purple" onClick={handleExportInvoice}>
            EXPORT INVOICE
          </Button>
        )}
      </Grid.Row>
      <br />
      <Divider hidden />
      <Grid.Row>
      <Grid columns="five">
          <Grid.Row>
            <Grid.Column>
              <Field name="refFile" component={ImageFileUploadFileId} />
              {imageUrl && (
                <p
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    window.open(
                      ImageUrl + imageUrl,
                      "_blank",
                      "noopener,noreferrer"
                    )
                  }
                >
                  Download
                </p>
              )}
            </Grid.Column>
            <Grid.Column>
              <Field name="refFile2" component={ImageFileUploadFileId} />
              {imageUrl && (
                <p
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    window.open(
                      ImageUrl + imageUrl2,
                      "_blank",
                      "noopener,noreferrer"
                    )
                  }
                >
                  Download
                </p>
              )}
            </Grid.Column>
            <Grid.Column>
              <Field name="refFile3" component={ImageFileUploadFileId} />
              {imageUrl && (
                <p
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    window.open(
                      ImageUrl + imageUrl3,
                      "_blank",
                      "noopener,noreferrer"
                    )
                  }
                >
                  Download
                </p>
              )}
            </Grid.Column>
            <Grid.Column>
              <Field name="refFile4" component={ImageFileUploadFileId} />
              {imageUrl && (
                <p
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    window.open(
                      ImageUrl + imageUrl4,
                      "_blank",
                      "noopener,noreferrer"
                    )
                  }
                >
                  Download
                </p>
              )}
            </Grid.Column>
            <Grid.Column>
              <Field name="refFile5" component={ImageFileUploadFileId} />
              {imageUrl && (
                <p
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    window.open(
                      ImageUrl + imageUrl5,
                      "_blank",
                      "noopener,noreferrer"
                    )
                  }
                >
                  Download
                </p>
              )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
        <br />
        <Grid columns="eight">
          <Grid.Row>
            {/* <Grid.Column>
              <Field
                name="invoiceName"
                label="To"
                type="text"
                component={renderTextField}
              />
            </Grid.Column> */}
            <Grid.Column>
              {" "}
              <Field
                name="invoiceDate"
                label="Date"
                type="date"
                component={renderTextField}
              />
            </Grid.Column>

            <Grid.Column>
              {" "}
              <Field
                name="invoiceName" //new
                label="Customer Name"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Field
              label="Status"
              name="status"
              options={statusVal}
              component={renderOptionField}
            />
            <Grid.Column>
              {" "}
              <Field
                name="customerContact" //new
                label="Customer Mobile"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              {" "}
              {/* <Field
                name="invoiceNumber"
                label="Invoice"
                type="text"
                disabled="true"
                component={renderTextField}
              /> */}
              <label>
                <b>Invoice</b>
              </label>
              <br />
              <div
                style={{
                  marginTop: "12px",
                }}
              >
                <label
                  style={{
                    padding: "7px",
                    border: "1px solid gray",
                    borderRadius: "5px",
                  }}
                >
                  <b>{rawData?.invoiceNumber}</b>
                </label>
              </div>
            </Grid.Column>
            <Grid.Column>
              {" "}
              <Field
                name="reference"
                label="Reference"
                type="text"
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              {" "}
              <Field
                name="personName"
                label="Person Name"
                // options={branding}
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column>
              <Field
                name="workName"
                label="Work Name"
                options={itemDesList}
                component={renderOptionField}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Grid.Row>
      <Divider hidden /> <Divider hidden />
      {/* <Table fixed>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>
              <Field
                name="invoiceName"
                label="To"
                type="text"
                component={renderTextField}
              />
            </Table.HeaderCell>
            <Table.HeaderCell>
              {" "}
              <Field
                name="invoiceDate"
                label="Date"
                type="date"
                component={renderTextField}
              />
            </Table.HeaderCell>
            <Table.HeaderCell>
              <Field
                name="dueDate"
                label="Due Date"
                type="date"
                component={renderTextField}
              />
            </Table.HeaderCell>
            <Table.HeaderCell>
              {" "}
              <Field
                name="invoiceNumber"
                label="Invoice"
                type="text"
                component={renderTextField}
              />
            </Table.HeaderCell>
            <Table.HeaderCell>
              {" "}
              <Field
                name="reference"
                label="Reference"
                type="text"
                component={renderTextField}
              />
            </Table.HeaderCell>
            <Table.HeaderCell>
              {" "}
              <Field
                name="branding"
                label="Branding"
                type="text"
                component={renderTextField}
              />
            </Table.HeaderCell>
            <Table.HeaderCell>
              {" "}
              <Field
                name="amountsAre"
                label="Amounts Are"
                options={amountsAre}
                component={renderOptionField}
              />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
      </Table> */}
      <div>
        <FieldArray
          name="itemList"
          itemCategory="new-invoice"
          totalAmountSum={totalAmount}
          component={NewInvoivceFieldArr}
        />
      </div>
      <Divider hidden />
      <>
        {" "}
        <Button
          type="submit"
          floated="right"
          positive
          disabled={buttonDisable}
          onClick={handleSubmit((values) =>
            sumbitForm({
              ...values,
              userId: userDetail.userId,
              categoryId: catid,
            })
          )}
        >
          Save
        </Button>
        <Button
          floated="right"
          negative
          disabled={pristine || submitting}
          onClick={reset}
        >
          Cancel
        </Button>
      </>
    </div>
  );
};

export default reduxForm({
  form: "NewInvoiceIndia",
})(NewInvoiceIndia);
